import { MicroservicePipelineFactory } from "../../factories/microservice-pipeline-factory";
import { BobRequest } from "../../model/bob-request";
import { Microservice } from "../../model/microservice";
import { BaseChainableComponent } from "../pipeline/base-chainable-component";
import { IProcessable } from "../pipeline/processable.interface";

export class MicroserviceLoaderComponent extends BaseChainableComponent<BobRequest> implements IProcessable<BobRequest> {

	private microservicePipelineFactory: MicroservicePipelineFactory;

	public setMicroservicePipelineFactory(microservicePipelineFactory: MicroservicePipelineFactory) {
		this.microservicePipelineFactory = microservicePipelineFactory;
	}

	public async process(input: BobRequest) {
		const microservices = input.microservices;

		const microservicePipelines = this.startPipelines(microservices);
		await this.setIsLoadedForSuccessfulPipelines(microservicePipelines, microservices);

		return await this.next.process(input);

	}

	private getMicroservicePipelineFactory() {
		return this.microservicePipelineFactory;
	}

	private startPipelines(microservices: Microservice[]) {
		return microservices.map((microservice) => {
			const microservicePipeline = this.getMicroservicePipelineFactory().create();
			return microservicePipeline.run(microservice);
		});
	}

	private async setIsLoadedForSuccessfulPipelines(microservicePipelines, microservices) {

		for (const index in microservicePipelines) {
			try {
				await microservicePipelines[index];

				microservices[index].isLoaded = true;
			} catch (error) {
				this.logger.error(error);
			}
		}
	}
}
